import React, { useState } from "react";
import { useTranslation } from "react-i18next";

const Facilities = () => {
  const { t } = useTranslation();
  const [showAll, setShowAll] = useState(false);

  return (
    <div className="list-trip">
      <h4>{t("title1")}</h4>
      <ul className="list-unstyled p-0 m-0">
        <li>
          <div className="form-check d-flex align-items-baseline justify-content-between gap-3">
            <div className="radioBox">
              <input className="form-check-input" type="checkbox" id="gridCheck1" />
              <label className="form-check-label" htmlFor="gridCheck1">
                {t("parking1")}
              </label>
            </div>
            <div className="d-flex align-items-center text-right-box">120</div>
          </div>
        </li>

        <li>
          <div className="form-check d-flex align-items-baseline justify-content-between gap-3">
            <div className="radioBox">
              <input className="form-check-input" type="checkbox" id="gridCheck2" />
              <label className="form-check-label" htmlFor="gridCheck2">
                {t("restaurant")}
              </label>
            </div>
            <div className="d-flex align-items-center text-right-box">21</div>
          </div>
        </li>

        <li>
          <div className="form-check d-flex align-items-baseline justify-content-between gap-3">
            <div className="radioBox">
              <input className="form-check-input" type="checkbox" id="gridCheck3" />
              <label className="form-check-label" htmlFor="gridCheck3">
                {t("roomService")}
              </label>
            </div>
            <div className="d-flex align-items-center text-right-box">62</div>
          </div>
        </li>

        <li>
          <div className="form-check d-flex align-items-baseline justify-content-between gap-3">
            <div className="radioBox">
              <input className="form-check-input" type="checkbox" id="gridCheck4" />
              <label className="form-check-label" htmlFor="gridCheck4">
                {t("frontDesk")}
              </label>
            </div>
            <div className="d-flex align-items-center text-right-box">33</div>
          </div>
        </li>

        <li>
          <div className="form-check d-flex align-items-baseline justify-content-between gap-3">
            <div className="radioBox">
              <input className="form-check-input" type="checkbox" id="gridCheck5" />
              <label className="form-check-label" htmlFor="gridCheck5">
                {t("fitnessCenter")}
              </label>
            </div>
            <div className="d-flex align-items-center text-right-box">25</div>
          </div>
        </li>

        {showAll && (
          <li>
            <div className="form-check d-flex align-items-baseline justify-content-between gap-3">
              <div className="radioBox">
                <input className="form-check-input" type="checkbox" id="gridCheck6" />
                <label className="form-check-label" htmlFor="gridCheck6">
                  {t("extraFrontDesk")}
                </label>
              </div>
              <div className="d-flex align-items-center text-right-box">25</div>
            </div>
          </li>
        )}
      </ul>

      <div className="drop-box-price">
        <button
          type="button"
          className="btn-text bg-transparent border-0 d-flex align-items-center gap-2"
          onClick={() => setShowAll(!showAll)}
        >
          <span>{showAll ? t("showLess") : t("showAll")}</span>
          <svg width="15" height="9" viewBox="0 0 15 9" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M1 1L7.5 7L14 1"
              stroke="#33A7F6"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default Facilities;
